<template>
  <div class="profile__card">
    <slot></slot>
  </div>
</template>

<script>
export default {}
</script>

<style lang="scss" scoped>
.profile__card {
  padding: 20px 40px;
  box-shadow: rgba(112, 144, 176, 0.08) 14px 17px 40px 4px;
  border-radius: 20px;
  background-color: #fff;
  width: 100%;
}
</style>
